import { render, staticRenderFns } from "./SendConfirm.vue?vue&type=template&id=69245aee&scoped=true"
import script from "./SendConfirm.vue?vue&type=script&lang=js"
export * from "./SendConfirm.vue?vue&type=script&lang=js"
import style0 from "./SendConfirm.vue?vue&type=style&index=0&id=69245aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69245aee",
  null
  
)

export default component.exports